import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=7e4f3c8c&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4f3c8c')) {
      api.createRecord('7e4f3c8c', component.options)
    } else {
      api.reload('7e4f3c8c', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=7e4f3c8c&", function () {
      api.rerender('7e4f3c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/configuration/Email.vue"
export default component.exports